import firedux from '../firedux'
import {dispatch} from '../store'

import {
  GROUP_CHAT_ORDERS_ENDPOINT,
  GROUP_CHAT_SCOPES
} from '../../config/constants'

import setGroupChatOrders from '../actions/set_group_chat_orders'

const onGroupOrders = (scope, snapshot) => dispatch(setGroupChatOrders(snapshot.val(), scope))
const onGlobalGroupOrders = (snapshot) => onGroupOrders(GROUP_CHAT_SCOPES.GLOBAL, snapshot)

export const watchGlobalGroupOrders = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ORDERS_ENDPOINT).child(GROUP_CHAT_SCOPES.GLOBAL)

  ref.on('value', onGlobalGroupOrders)
}

export const unwatchGlobalGroupOrders = () => {
  const ref = firedux.ref.child(GROUP_CHAT_ORDERS_ENDPOINT).child(GROUP_CHAT_SCOPES.GLOBAL)

  ref.off('value', onGlobalGroupOrders)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/group_chat_orders.js
 **/